import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/types'
import createPersistedState from 'vuex-persistedstate'
import auth from '@/store/auth'
import moderatorPreferences from '@/store/moderator-preferences'
import posts from '@/store/posts'
import tags from '@/store/tags'
import towns from '@/store/towns'
import townMemberships from '@/store/town-memberships'
import users from '@/store/users'

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    auth,
    moderatorPreferences,
    posts,
    tags,
    towns,
    townMemberships,
    users
  },
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ]
};

export default new Vuex.Store<RootState>(store);
